export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Ejemplar',
  type: 'bibliography/bibl_sample',
  bodyClasses: 'biblio-layout',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
    ],
    content: [
      {
        id: 'image-viewer',
        type: 'viewer',
        grid: 3,
        tools: true,
        title: 'resource#image-viewer',
      },
      {
        id: 'parent-record',
        type: 'collection',
        grid: 3,
        title: 'resource#parent-record',
      },
      {
        id: 'parent-edition',
        type: 'collection',
        grid: 1,
        title: 'resource#parent-edition',
      },
      {
        id: 'metadata',
        type: 'metadata',
        title: 'resource#metadata'
      },
      {
        id: 'collection-digital-editions',
        type: 'collection',
        grid: 1,
        title: 'resource#collection-text',
      },
    ],
  },
};
